import { decodeSessionJwt } from "@/components/authentication/utils";
import { getAllTools } from "@/features/branding/tools";
import severitiesTool from "@/tools/aggregate/severities";
import { useSession } from "@supabase/auth-helpers-react";
import { useMemo } from "react";

/** Whether the current user has the Severities tool: enabled in this Hub's config and user permissions. */
export const useCanUseSeverities = () => {
  const session = useSession();
  return useMemo(() => {
    const toolsEnabled: string[] = decodeSessionJwt(session)?.user_metadata?.tools_enabled ?? [];
    return toolsEnabled.includes(severitiesTool.keyPrefix) && getAllTools().some(({ id }) => id === severitiesTool.id);
  }, [session]);
};
